/**
 * Dependency-free entry: ONLY the error classes and their structural guards.
 *
 * The main entry (`.`) re-exports the client, which is browser code. Consumers
 * that merely need to CLASSIFY an error — the transaction-replay helper that the
 * server bundle reaches through `wrap-actor-database.ts`, for one — import this
 * subpath so they never drag the client into a bundle that cannot run it.
 */
export {
  isLeaderChangedError,
  isLeaderUnavailableError,
  LeaderChangedError,
  LeaderUnavailableError,
} from "#leader-resource-errors";
